export const liabilityfaqList = [
  {
    question: `General liability vs. workers' compensation insurance`,
    answer: `Both general liability insurance and workers' compensation are distinct but related. Both programmes serve various functions but are intended for business owners and contractors. Because they are interconnected, it is recommended that contractors implement both policies in order to run a successful business.`,
  },
  {
    question: 'What is not covered in a liability insurance policy?',
    answer: `<li>Any deliberate attempt to violate legal or legitimate provisions.</li>
      <li>Property damage sustained by the insured. Also, if the property is leased or financed in the insured's name.</li>
      <li>Loss or destruction caused by a conflict, raid, civil war, rebellion, insurgency, or military strike.</li>
      <li>Any loss or damage caused by radioactivity, ionising radiation, nuclear waste, or hazardous explosions, whether direct or indirect.</li>
      `,
  },
  {
    question: 'Do I need Public Liability insurance?',
    answer:
      "This is up to you to decide, as it is not a legal requirement. If you regularly interact with the public, clients and contractors, however, it is highly recommended. Even if you're taking all measures possible to avoid them, accidents do happen, and a legal battle ensuing one could be highly damaging to your business if you don't have the means to face it.",
  },
  {
    question: 'Does Public Liability insurance cover my employees as well?',
    answer: `No, public liability is not designed to cover your employees - it is only intended to protect you from third party claims made by members of the public. Your employees will be covered by the mandatory employers' liability insurance policy you need to have in place to protect them from workplace accidents or illnesses.`,
  },
];
